import { render, staticRenderFns } from "./noorPlayGrid.vue?vue&type=template&id=19dd4ba6&scoped=true&"
import script from "./noorPlayGrid.vue?vue&type=script&lang=js&"
export * from "./noorPlayGrid.vue?vue&type=script&lang=js&"
import style0 from "./noorPlayGrid.vue?vue&type=style&index=0&id=19dd4ba6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dd4ba6",
  null
  
)

export default component.exports